var _rect, _line, _line2, _line3, _circle, _circle2, _text, _text2, _rect2, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _line4, _line5, _line6, _line7, _rect6, _text7, _rect7, _text8, _circle3, _text9, _text0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAgentWorkflowCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#0f1a0f"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 90,
    x2: 640,
    y2: 90,
    stroke: "#4a7a3a",
    strokeWidth: 0.4,
    opacity: 0.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 180,
    x2: 640,
    y2: 180,
    stroke: "#4a7a3a",
    strokeWidth: 0.4,
    opacity: 0.15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 270,
    x2: 640,
    y2: 270,
    stroke: "#4a7a3a",
    strokeWidth: 0.4,
    opacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 36,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 28,
    fill: "#1a2e1a",
    stroke: "#4a7a3a",
    strokeWidth: 0.8,
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 176,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fill: "#6aaa58"
  }, "Router")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 189,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 7.5,
    fill: "#4a7a3a"
  }, "ReAct")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 80,
    width: 80,
    height: 36,
    rx: 6,
    fill: "#1a2e1a",
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.85
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 101,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8.5,
    fill: "#6aaa58"
  }, "SQL Expert")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 244,
    width: 80,
    height: 36,
    rx: 6,
    fill: "#1a2e1a",
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.85
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 265,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8.5,
    fill: "#6aaa58"
  }, "File Expert")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 80,
    width: 86,
    height: 36,
    rx: 6,
    fill: "#1a2e1a",
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.85
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 531,
    y: 101,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8.5,
    fill: "#6aaa58"
  }, "Mail Manager")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 244,
    width: 86,
    height: 36,
    rx: 6,
    fill: "#1a2e1a",
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.85
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 531,
    y: 265,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8.5,
    fill: "#6aaa58"
  }, "General Agent")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 284,
    y1: 163,
    x2: 152,
    y2: 112,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5,
    strokeDasharray: "4,3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 284,
    y1: 197,
    x2: 152,
    y2: 248,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5,
    strokeDasharray: "4,3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 356,
    y1: 163,
    x2: 488,
    y2: 112,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5,
    strokeDasharray: "4,3"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 356,
    y1: 197,
    x2: 488,
    y2: 248,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5,
    strokeDasharray: "4,3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 22,
    width: 96,
    height: 22,
    rx: 4,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 0.8,
    opacity: 0.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 37,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8,
    fill: "#4a7a3a",
    opacity: 0.8
  }, "MCP \xB7 LangChain")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 316,
    width: 144,
    height: 22,
    rx: 4,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 0.8,
    opacity: 0.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 331,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8,
    fill: "#4a7a3a",
    opacity: 0.8
  }, "Plan-Execute \xB7 HITL")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 4,
    fill: "#6aaa58",
    opacity: 0.9
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 338,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.2,
    letterSpacing: 3
  }, "AI AGENT WORKFLOW \xB7 MULTI-AGENT PLATFORM")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 42,
    fontFamily: "Georgia, serif",
    fontSize: 9,
    fill: "#4a7a3a",
    letterSpacing: 4
  }, "LANGCHAIN \xB7 MCP \xB7 FASTAPI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAgentWorkflowCover);
export default __webpack_public_path__ + "static/media/ai-agent-workflow-cover.3c5a1ff114b139b299f0df6c52079f82.svg";
export { ForwardRef as ReactComponent };